"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LeafLined = function LeafLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.777 2.081a.505.505 0 00-.746.242c-.009.023-.939 2.261-6.652 3.69C6.943 6.872 3 8.385 3 12.5a3.5 3.5 0 001.347 2.867 3.7 3.7 0 001.718.692 4.286 4.286 0 00-1.021 3.2 3.384 3.384 0 002.326 2.707.5.5 0 00.362-.932 2.4 2.4 0 01-1.7-1.909 3.413 3.413 0 011.094-2.74A5.207 5.207 0 0012.051 20h.5C17.052 20 21 15.092 21 9.5c0-5.21-3.091-7.331-3.223-7.419zM12.551 19h-.5C10.178 19 8 17.47 8 15.5c0-3.4 2.646-4.216 5.205-5.009C15.157 9.885 17 9.314 17 7.5a.5.5 0 10-1 0c0 1.027-1.174 1.443-3.091 2.037-2.4.745-5.653 1.763-5.886 5.534a2.793 2.793 0 01-2.07-.5A2.478 2.478 0 014 12.5c0-2.706 1.98-4.355 6.621-5.516C15.2 5.838 16.98 4.145 17.63 3.255A8.359 8.359 0 0120 9.5c0 4.971-3.55 9.5-7.449 9.5z",
    fill: "currentColor"
  })));
};

var _default = LeafLined;
exports["default"] = _default;